export const KPISLIST_SEARCH = 'KPISLIST_SEARCH';
export const KPISLIST_PAGE = 'KPISLIST_PAGE';
export const KPISLIST_STARTDATE = 'KPISLIST_STARTDATE';
export const KPISLIST_ENDDATE = 'KPISLIST_ENDDATE';
export const KPISLIST_ACTIVITYLABELID = 'KPISLIST_ACTIVITYLABELID';
